// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--aLtlx","text":"_103a151b99--text--aZKuQ"};